import React, { useState } from "react";
import { maskEmail } from "../../utils/maskEmail";
import axios from "../../libs/axios";
import { BeatLoader } from "react-spinners";
import { toast } from "react-hot-toast";

export default function EmailSend({ email, nextStep, role, tel }) {
  const maskedEmail = maskEmail(email);
  const [loading, setLoading] = useState(false);
  const [changeNumberVisible, setChangeNumberVisible] = useState(false);
  const [newNumber, setNewNumber] = useState("");

  const onSendVerifyCode = () => {
    setLoading(true);
    axios
      .post(`/${role}/send/verify`, {
        email: email,
      })
      .then((res) => {
        nextStep();
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handleNumberChange = async (e) => {
    e.preventDefault();

    if (!newNumber) {
      toast.error("მობილურის ნომრის ველი აუცილებელია.");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(`/${role}/change-number`, {
        email,
        tel: newNumber,
      });

      if (res.status !== 200)
        throw new Error(
          "მობილურის ნომრის შეცვლა ვერ მოხერხდა. გთხოვთ დაგვიკავშირდეთ."
        );

      toast.success("ნომერი წარმატებით შეიცვალა, დაელოდეთ ვერიფიკაციის კოდს.");
      setChangeNumberVisible(false);
      setNewNumber(false);
      onSendVerifyCode();
    } catch (error) {
      console.log(error);
      toast.error(error?.message || "დაფიქსირდა შეცდომა. მოგვიანებით სცადეთ.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full md:w-2/3 h-[85dvh] flex justify-center items-center mx-auto p-6">
      <div className="card w-full lg:w-1/2 bg-base-100 shadow-xl mx-auto mt-6">
        <div className="card-body flex justify-center items-start flex-col gap-5">
          {loading ? (
            <div className="w-full h-full flex justify-center items-center">
              <BeatLoader />
            </div>
          ) : (
            <>
              <h2>
                გაგზავნეთ დამადასტურებელი კოდი მობილურის ნომერზე:{" "}
                <strong>{tel}</strong>
              </h2>
              <div className="flex flex-wrap gap-1">
                <button
                  disabled={loading}
                  onClick={onSendVerifyCode}
                  type="button"
                  className="px-8 btn btn-sm btn-success text-white rounded-full py-1"
                >
                  კოდის გაგზავნა
                </button>
                <button
                  disabled={changeNumberVisible}
                  onClick={(e) => setChangeNumberVisible(!changeNumberVisible)}
                  type="button"
                  className="px-8 btn btn-sm btn-neutral text-white rounded-full py-1"
                >
                  ნომრის შეცვლა
                </button>
              </div>
              {changeNumberVisible && (
                <form onSubmit={(e) => handleNumberChange(e)}>
                  <div>
                    <label htmlFor="new_number">ახალი მობილურის ნომერი</label>
                    <input
                      value={newNumber}
                      onChange={(e) => setNewNumber(e.target.value)}
                      type="number"
                      id="new_number"
                      className="w-full mt-2 px-3 py-2 border border-gray-300 rounded-md text-md text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                      placeholder="მაგ: 555112233"
                      required
                    />
                  </div>
                  <div className="flex flex-wrap gap-1 mt-3">
                    <button
                      disabled={loading}
                      type="submit"
                      className="px-8 btn btn-sm btn-primary text-white rounded-full py-1"
                    >
                      შეცვლა
                    </button>
                    <button
                      onClick={(e) =>
                        setChangeNumberVisible(!changeNumberVisible)
                      }
                      type="button"
                      className="px-8 btn btn-sm btn-error text-white rounded-full py-1"
                    >
                      გაუქმება
                    </button>
                  </div>
                </form>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
